module.exports = __webpack_public_path__ + "static/media/photo-right-fourth.877169e2.png";